import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CookieBanner from './components/ui/CookieBanner';
import AgeModal from './components/ui/AgeModal';
import ScrollToTop from './components/ui/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Help from './pages/Help';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import HowWeReview from './pages/HowWeReview';
import ResponsibleGambling from './pages/ResponsibleGambling';
import CasinoGuide from './pages/CasinoGuide';

function App() {
  const [ageConfirmed, setAgeConfirmed] = useState(() => {
    return localStorage.getItem('tcd_age_confirmed') === 'true';
  });
  const [cookiesAccepted, setCookiesAccepted] = useState(() => {
    return localStorage.getItem('tcd_cookies_accepted') === 'true';
  });

  const handleAgeConfirm = () => {
    localStorage.setItem('tcd_age_confirmed', 'true');
    setAgeConfirmed(true);
  };

  const handleCookiesAccept = () => {
    localStorage.setItem('tcd_cookies_accepted', 'true');
    setCookiesAccepted(true);
  };

  return (
    <Router>
      <ScrollToTop />
      {!ageConfirmed && <AgeModal onConfirm={handleAgeConfirm} />}
      <div className="app-wrapper" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/hjaelp" element={<Help />} />
            <Route path="/privatlivspolitik" element={<PrivacyPolicy />} />
            <Route path="/cookiepolitik" element={<CookiePolicy />} />
            <Route path="/vores-metode" element={<HowWeReview />} />
            <Route path="/ansvarligt-spil" element={<ResponsibleGambling />} />
            <Route path="/casino-guide" element={<CasinoGuide />} />
          </Routes>
        </main>
        <Footer />
        {!cookiesAccepted && ageConfirmed && (
          <CookieBanner onAccept={handleCookiesAccept} />
        )}
      </div>
    </Router>
  );
}

export default App;
